"use client";
import { CalendarPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import * as React from "react";
import { cn } from "@/lib/utils";

interface LoadEventsButtonProps {
  onClick: () => void;
  "data-testid"?: string;
  children: React.ReactNode;
  className?: string;
}

export function LoadEventsButton({
  onClick,
  children,
  "data-testid": dataTestId,
  className,
}: LoadEventsButtonProps) {
  return (
    <div
      className={cn("relative border-t p-6", className)}
      style={{ borderTopColor: "var(--table-border-color)" }}
    >
      <div className="flex flex-col items-center gap-3 text-center">
        <Button
          type="button"
          size="lg"
          data-testid={dataTestId}
          onClick={onClick}
          variant="outline"
          className="group relative inline-flex gap-2 rounded-full px-7 py-3 text-base font-medium"
        >
          <CalendarPlus className="relative size-5 shrink-0 transition-transform duration-300 ease-out group-hover:scale-110" />
          <span className="relative">{children}</span>
        </Button>
      </div>
    </div>
  );
}
